export default __webpack_public_path__ + "static/media/Golden-Snitch-3D-Model-01.3acb9925.jpg";